import React from 'react'
import ffffff from '../image/ffffff.avif'
import { styled } from '@mui/system'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}))

function BA_FAQ_page() {
  return (
    <div>
      <div className="mt-5">
        <div className="container pt-3">
          <div className="text-center Curriculum_Main_text">
            <div className="">
              <h2 className="display-6">Frequently Asked Questions</h2>
              <p className="pt-2">
                Our Responses to Your Inquiries: Unblocking the Way to Clarity
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <div className="FAQ_img">
                <img
                  src={ffffff}
                  onContextMenu={(e) => e.preventDefault()}
                ></img>
              </div>
            </div>
            <div className="col-md-7 pt-5 d-none d-md-block">
              <div className="pt-5">
                <div className="pt-5">
                  <div className="pt-5">
                    <BA_FAQ />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 d-sm-block d-md-none mb-5">
              <BA_FAQ />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function BA_FAQ() {
  const classes = useStyles()
  const [expanded, setExpanded] = React.useState(false)

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }
  return (
    <>
      <div className={classes.root}>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel1'}
          onChange={handleChange('panel1')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            className="FAQ_background_color"
          >
            <Typography className="fs-5">
              What skills are essential to succeed in Business Analytics?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Key skills include proficiency in data analysis tools like SQL,
              Python, and R, expertise in Excel, knowledge of data visualization
              tools (e.g., Tableau, Power BI), understanding statistical
              analysis, and strong problem-solving abilities. Business acumen
              and communication skills are also crucial.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel2'}
          onChange={handleChange('panel2')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2bh-content"
            id="panel2bh-header"
            className="FAQ_background_color"
          >
            <Typography className="fs-5">
              What is the career path in Business Analytics?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Common roles start with entry-level positions like Data Analyst or
              Junior Business Analyst, progressing to Senior Business Analyst,
              Data Scientist, or Analytics Manager. With experience, one can
              advance to roles like Chief Data Officer (CDO) or Director of
              Analytics.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel3'}
          onChange={handleChange('panel3')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3bh-content"
            id="panel3bh-header"
            className="FAQ_background_color"
          >
            <Typography className="fs-5">
              How important are certifications for a career in Business
              Analytics?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Certifications like Certified Business Analysis Professional
              (CBAP), Google Data Analytics Certificate, or certifications in
              tools like SAS, Tableau, and Power BI can boost career prospects.
              They validate skills and can make candidates more competitive in
              the job market.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel4'}
          onChange={handleChange('panel4')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel4bh-content"
            id="panel4bh-header"
            className="FAQ_background_color"
          >
            <Typography className="fs-5">
              What industries hire business analysts?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Business analysts are in demand across industries such as finance,
              healthcare, retail, e-commerce, consulting, and technology. Any
              sector that relies on data to inform decision-making will value
              business analysts.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel5'}
          onChange={handleChange('panel5')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel5bh-content"
            id="panel5bh-header"
            className="FAQ_background_color"
          >
            <Typography className="fs-5">
              How can I transition into Business Analytics from a different
              field?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Start by gaining knowledge in analytics tools and techniques
              through online courses or certifications. Hands-on practice with
              real datasets, personal projects, or internships can help build a
              portfolio. Networking with professionals and attending industry
              events are also beneficial.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div>
    </>
  )
}
export default BA_FAQ_page
